import { render, staticRenderFns } from "./TagsBadgeList.vue?vue&type=template&id=56cbc82f&scoped=true&"
import script from "./TagsBadgeList.vue?vue&type=script&lang=js&"
export * from "./TagsBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./TagsBadgeList.vue?vue&type=style&index=0&id=56cbc82f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbc82f",
  null
  
)

export default component.exports